export const MONTHLY = 1
export const ANNUALLY = 12

export type BillingPeriodType = typeof MONTHLY | typeof ANNUALLY
